export const isAdmin = (role: string) => role === "admin";
export const isEditor = (role: string) => role === "editor";
export const isViewer = (role: string) => role === "viewer";
